import React from 'react';
import Gallery from '../components/Gallery';
import { corporateEventsImages } from '../data/images';

const CorporateEvents = () => {
  return (
    <div className="gallery-page">
      <section 
        className="hero-half"
        style={{
          backgroundImage: `url('/images/dvi-hero.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-content">
          <h1>Corporate Events</h1>
          <p>
            Professional event documentation for corporate gatherings, conferences, and business celebrations. 
            We capture the essence of your corporate events with precision and professionalism.
          </p>
        </div>
      </section>
      
      <section className="gallery-section">
        <div className="container">
          <Gallery images={corporateEventsImages} sectionId="corporate-events" />
        </div>
      </section>

    </div>
  );
};

export default CorporateEvents;
